export default __webpack_public_path__ + "static/media/Poppins-Regular.13c7a7ea.eot";